import { api } from 'app/utils/api/helpers'

const NOTE_TARGET_PM_CONFIRMATION = 24
const NOTE_TARGET_UNDO_PM_CONFIRMATION = 25

export const fetchAIAnalysisOfDocuments = (documentIds, agencyGUID) => {
  return api.get(
    `sm/doc-analysis/analysis/smartdocs?${documentIds}&agency_id=${agencyGUID}`,
  )
}

export const fetchAIAnalysisOfDocumentPoller = (documentId) => {
  return api.get(`sm/doc-analysis/${documentId}/status`)
}

export const fetchAIAnalysisOfDocumentForPM = (applicantGUID, agencyGUID) => {
  return api.get(
    `sm/doc-analysis/analysis/smartdocs?applicant_id=${applicantGUID}&agency_id=${agencyGUID}`,
  )
}

export const postRenterConfirmation = (documentId) => {
  return api.post(`sm/doc-analysis/analysis/${documentId}/confirm`, {
    confirmation_type: 'renter_confirmed',
  })
}

export const postPMConfirmation = (documentId, applicationGUID, agencyGUID) => {
  return api.post(`sm/doc-analysis/analysis/${documentId}/confirm`, {
    confirmation_type: 'pm_confirmed',
    application_id: applicationGUID,
    agency_id: agencyGUID,
    note_target: NOTE_TARGET_PM_CONFIRMATION,
  })
}

export const undoRenterConfirmation = (documentId, confirmationID) => {
  return api.post(
    `sm/doc-analysis/analysis/${documentId}/confirm/${confirmationID}/undo`,
    {},
  )
}

export const undoPMConfirmation = (
  documentId,
  confirmationID,
  applicationID,
) => {
  return api.post(
    `sm/doc-analysis/analysis/${documentId}/confirm/${confirmationID}/undo`,
    {
      application_id: applicationID,
      note_target: NOTE_TARGET_UNDO_PM_CONFIRMATION,
    },
  )
}

export const fetchCopilotAnalysis = (
  applicationGUID,
  applicantID,
  agencyGUID,
) => {
  return api.get(
    `sm/doc-analysis/agencies/${agencyGUID}/applications/${applicationGUID}/copilot`,
  )
}
